import { BaseWithId, BaseModel } from '@app/shared/models/base';

export enum MessageState {
    NEW = 'NEW',
    READ = 'READ'
};

export class MessageData extends BaseModel {

    public new_messages_count: number;

    constructor(json?) {
        super(json);
    }
}

export class Message extends BaseWithId {
    
    public client_id: string;
    public receiver_id: string;
    public date: Date;
    public message: string;
    public link: string;
    public state: MessageState; 
    
    constructor(json?) {
        super(json);
    }
}
